import { forwardRef, PropsWithChildren } from 'react'
import Styles from './ToastMessage.module.scss'
export const Action = forwardRef<HTMLDivElement, PropsWithChildren<any>>(({ children }, fRef) => (
  <div ref={fRef} className={Styles.action}>
    {children}
  </div>
))
